import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import CusProgressBar from '../components/CusProgressBar';
import {CusFormSectionLabel, FormComboBox, FormTitleTooltip} from '../validation/Form-Components';
import {reqDDLValidator, requiredValidator} from '../validation/Validators';
import config from '../appconfig/config.json';
import service from '../services/ApiService';
import { useHistory } from "react-router-dom";
import SubHeader from '../components/SubHeader';
import appDetailsData from '../data/applicantdetailsdata.json';
import countryCodes from '../data/countrycode.json';
import Loading from '../components/Loading';
import helper from '../factory/Helper.js';
import AuthPerson from './AuthPerson';
import CusAddBtn from '../components/CusAddBtn';
import CusRemoveBtn from '../components/CusRemoveBtn';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import occupations from '../data/industrylist.json';
import countriesRisk from '../data/countrieswealth.json';
import countriesDomicile from '../data/domicilecountries.json';
import uploadConfig from '../data/uploaddetailsdata.json';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
 
let showAuthPerson2 = false, showAuthPerson3 = false;
let MailAddrSameAsRes1='Y',MailAddrSameAsRes2='Y',MailAddrSameAsRes3='Y';
let PersWealthSG1='Y',PersWealthSG2='Y',PersWealthSG3='Y';
let pureSHApplicants = []; // Added as Authorised Person with Shareholder postion
 

const NSApplicantDetails = (props) => {
  
    let timer;
    const pureSHPositionCode = '000';
    const detailsType='3', authPer1 = '1', authPer2 = '2',authPer3 = '3', authPer0='0';

    const dobRegex = new RegExp(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);

    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 40 };

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [isSaveDone,setIsSaveDone] = useState(false);  //to pass the value when user clicked add or remove AP 
    const [isAPDtlsEdited, setIsAPDtlsEdited]  = useState(false); //if dropdown change or add/remove authorised person true,else false

    const [isExpendAuth1,setIsExpendAuth1] = useState(true);
    const [isExpendAuth2,setIsExpendAuth2] = useState(true);
    const [isExpendAuth3,setIsExpendAuth3] = useState(true);

    const [showAddBtn, setShowAddBtn] = useState(true);
    const [showAddBtn2, setShowAddBtn2] = useState(true);

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);

    const [display, setDisplay] = useState(false);

    const [hasMyInfo, setHasMyInfo] = useState(false);
    const [hasMyInfo2, setHasMyInfo2] = useState(false);
    const [hasMyInfo3, setHasMyInfo3] = useState(false);
 
    const [selectedName,setSelectedName] = useState({});
    const [selectedName2,setSelectedName2] = useState({});
    const [selectedName3,setSelectedName3] = useState({});

    const [holders, setHolders]  = useState([]);
    const [pureSholders,setPureSholders] = useState([]); 
  
    const [response, setResponse]  = useState();
    
    const initAppDtlsObj = {
        myInfo:{},
        occupList:[],
        allowEdit:true
    }
    const [applicantDetails, setApplicantDetails] = useState(initAppDtlsObj);

    const [applicantDetails2, setApplicantDetails2] = useState(initAppDtlsObj);

    const [applicantDetails3, setApplicantDetails3] = useState(initAppDtlsObj);

    const [appDtls0, setAppDtls0] = useState({});

    const [initFormData, setInitFormData] = useState({
        nameCbo1:"",
        titleCbo1:"",
        marStatusCbo1:"",
        counOfDomicileCbo1:"",
        mno1:"",
        em1:"",

        MailAddType1:config.addTypeLocal,
        MailBlkNo1: "",
        MailStreet1: "",
        MailFlrNum1: "",
        MailUnitNo1: "",
        MailBldName1: "",
        MailPostalCode1: "",
        MailCountry1:appDetailsData.DefCountry.label,
       
        DescActOcc11:'',
        DescActOcc21:'',
        DescActOcc31:'',
 
        SG1: false,
        BN1: false,
        MY1: false,
        CN1: false,
        ID1: false,
        IN1: false,
        OTH1: false,
        PersWealthOTH1: '',

        nameCbo2:'',
        mno2:"",
        em2:"",
        titleCbo2:"",
        marStatusCbo2:"",
        counOfDomicileCbo2:"",
        MailAddType2:config.addTypeLocal,
        MailBlkNo2: "",
        MailStreet2: "",
        MailFlrNum2: "",
        MailUnitNo2: "",
        MailBldName2: "",
        MailPostalCode2: "",
        MailCountry2:appDetailsData.DefCountry.label,

        DescActOcc12:'',
        DescActOcc22:'',
        DescActOcc32:'',

        SG2: false,
        BN2: false,
        MY2: false,
        CN2: false,
        ID2: false,
        IN2: false,
        OTH2: false,
        PersWealthOTH2: '',

        nameCbo3:'',
        mno3:"",
        em3:"",
        titleCbo3:"",
        marStatusCbo3:"",
        counOfDomicileCbo3:"",
        MailAddType3:config.addTypeLocal,
        MailBlkNo3: "",
        MailStreet3: "",
        MailFlrNum3: "",
        MailUnitNo3: "",
        MailBldName3: "",
        MailPostalCode3: "",
        MailCountry3:appDetailsData.DefCountry.label,
        DescActOcc13:'',
        DescActOcc23:'',
        DescActOcc33:'',
 
        SG3: false,
        BN3: false,
        MY3: false,
        CN3: false,
        ID3: false,
        IN3: false,
        OTH3: false,
        PersWealthOTH3: ''
    })

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        window.scrollTo(0,0);
        getStateId();
        initVariable();
        getData();

        return () => clearTimeout(timer);
    }, []);

    const initVariable = () => {
        showAuthPerson2 = false; showAuthPerson3 = false;
        MailAddrSameAsRes1='Y'; MailAddrSameAsRes2='Y'; MailAddrSameAsRes3='Y';
        PersWealthSG1='Y'; PersWealthSG2='Y'; PersWealthSG3='Y';
    }
    
     //show / hide ApplicantDetails
     const [showDetails, setShowDetails] = useState(false);
     const onShowDetails = (e) => {
         e.preventDefault();
         if(showDetails){
            setShowDetails(false)
         }
         else {
            setShowDetails(true);
         }
    }

    const createHolders = (data) => {
        let temp = [], pureSHTemp = [];
        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                temp.push(data.Holdersdetails);
                setHolders(temp);
                if(data.Holdersdetails.Designation === pureSHPositionCode) {
                    pureSHTemp.push(data.Holdersdetails);
                    setPureSholders(pureSHTemp);
                }
            }
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null){
                    temp.push(data.Holdersdetails[i]);
                    if(data.Holdersdetails[i].Designation === pureSHPositionCode) {
                        pureSHTemp.push(data.Holdersdetails[i]);
                        
                    }
                }
            }

            setHolders(temp);
            setPureSholders(pureSHTemp);
        }
    }

    const getHoldersDtls = (data) => {
        let temp = [];
        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                temp.push(data.Holdersdetails);
            }
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null){
                    temp.push(data.Holdersdetails[i]);
                }
            }
        }

        return temp;
    }

    const handleSubmit = (eve) => {
        
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
    
        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            if(!validateApplicantDtls()) {
                //goToErrorPage(config.ErrType.InvalidMyInfoPerson);
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') { //first user
                    showErrMsg(config.error.MyInfo.MissingData);
                }
                else {
                    showErrMsg(config.error.MyInfo.MissingDataSubAP);
                }
               
                return;
            }
            else if(!validateApplicantDtlsDOB()) {
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') { //first user
                    showErrMsg(config.error.MyInfo.InvalidDOB);
                }
                else {
                    showErrMsg(config.error.MyInfo.InvalidDOBSubAP);
                }
                return;
            }
            else if(!validatePersWealthCntyFormSubmit(data)){
                //console.log('one of the invalid fields')
                return;
            }
            else if(!isValidNumOfApplicants(formatJsonParams(data).ApplicantDtls)) {
                showErrMsg(appDetailsData.error.InvalidNumOfAP);
                return;
            }
 
           saveApplicantDetails(formatJsonParams(data));
        }
    }

    const validateApplicantDtls = () => {
        
        if(getLoginUserOrder() === authPer1 && hasMyInfo) {
            return validateMyInfoMandatoryFields(applicantDetails,'Authorised Person 1: ');
        }
        else if(getLoginUserOrder() === authPer2 && hasMyInfo2) {
         
            return validateMyInfoMandatoryFields(applicantDetails2,'Authorised Person 2: ');
        }
        else if(getLoginUserOrder() === authPer3 && hasMyInfo3) {
     
            return validateMyInfoMandatoryFields(applicantDetails3,'Authorised Person 3: ');
        }
        else {
            return true;
        }
    }

    const validateApplicantDtlsDOB = () => {
        if(getLoginUserOrder() === authPer1 && hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails,'Authorised Person 1: ');
        }
        else if(getLoginUserOrder() === authPer2 && hasMyInfo2) {
         
            return validateMyInfoDOBFormat(applicantDetails2,'Authorised Person 2: ');
        }
        else if(getLoginUserOrder() === authPer3 && hasMyInfo3) {
            return validateMyInfoDOBFormat(applicantDetails3,'Authorised Person 3: ');
        }
        else {
            return true;
        }
    }

    const getObjInArrayforCompType = (iValue, array) => {
        const result = array.find( ({ value }) => value === iValue);
        return result;
    }

    const checkCompType = (data) => {
        const compTypeCode = data.CompDtls.CompTypeCode !== null? data.CompDtls.CompTypeCode:data.RegBizMailAddr.CompTypeCode;
         
        if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario1CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO1);
        }
        else if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario2CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO2);
        }
        else if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario3CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO3);
        }
        else if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario4CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO4);
        }
        else {  
            storage.setCompType(uploadConfig.SCOType.SCO1);
        }
    }
    
    const saveApplicantDetails = (params) => {
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data
            if(resData.isSucess) {
            
                goNext();
            }  
            else{
                showErrMsg(config.error.SaveApiFailed);
            }         
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const validatePersWealthCntyFormSubmit = (data) => {
        let isValid=true;
        const errMsg =appDetailsData.label.ctrySourceWealth+": "+config.error.SelectChk5;
   
        if(getLoginUserOrder() === authPer1) {
            const json = formatApplicantObj1(data);
            if(!validateInputFields(json)){
                showErrMsg('Input the balnk fields');
                isValid=false;
            }
            else if(json.PersWealthSG === 'N') {
                if(!helper.validateNoOfCheckedBox(json.PersWealthCou,1,5)) {
                    showErrMsg(errMsg);
                    isValid=false;
                }
                else { 
                    isValid=true;
                }
            }
        }
        else if(getLoginUserOrder() === authPer2) {
            const json = formatApplicantObj2(data);
            if(!validateInputFields(json)){
                showErrMsg('Input the balnk fields');
                isValid=false;
            }
            else if(json.PersWealthSG === 'N') {
                if(!helper.validateNoOfCheckedBox(json.PersWealthCou,1,5)) {
                    showErrMsg(errMsg);
                    isValid=false;
                }
                else { 
                    isValid=true;
                }
            }
        }
        else if(getLoginUserOrder() === authPer3) {
            const json = formatApplicantObj3(data);
            if(!validateInputFields(json)){
                showErrMsg('Input the balnk fields');
                isValid=false;
            }
            else if(json.PersWealthSG === 'N') {
                if(!helper.validateNoOfCheckedBox(json.PersWealthCou,1,5)) {
                    showErrMsg(errMsg);
                    isValid=false;
                }
                else { 
                    isValid=true;
                }
            }
        }

        return isValid;
    }

    const validateAuthPerAllFields = (data) => {
         let authPer ={};
        if(getLoginUserOrder() === authPer1) {
            authPer = formatApplicantObj1(data);
        }
        else if(getLoginUserOrder() === authPer2){
            authPer = formatApplicantObj2(data);
        }
        else if(getLoginUserOrder() === authPer3) {
            authPer = formatApplicantObj3(data);
        }
    }

    const validateInputFields = (authPer) =>{
        let isValid = true;
        if(!validateNameMnoEmail(authPer)){
            isValid = false;
        } 
        else if(!validateMailingAddress(authPer)){
            isValid = false;
        }
        else if(!validateOtherFields(authPer)){
            isValid = false;
        }
        return isValid;
    }


    const validateNameMnoEmail = (authPerJson) =>{
  
        let isValid = true;
        if(authPerJson.Name === undefined) {
            isValid = false;
        }
        else if(authPerJson.MobileNo === undefined) {
            isValid = false;
        }
        else if(authPerJson.EmailAdd === undefined) {
            isValid = false;
        }
        return isValid;
    }

    const validateMailingAddress = (authPerJson) => {
        let isValid = true;
        if(authPerJson.MailAddrSameAsRes === 'N'){
            if(authPerJson.MailPostalCode === undefined){
                isValid = false;
            }
            else if(authPerJson.MailBlkNo === undefined) {
                isValid = false;
            }
            else if(authPerJson.MailStreet === undefined) {
                isValid = false;
            }
        }
    
        return isValid;
    }

    const validateOtherFields = (authPerJson) =>{
        let isValid = true;
       
        if(authPerJson.Title === undefined){
            isValid = false;
        }
        else if(authPerJson.MarStatus === undefined) {
            isValid = false;
        }
        else if(authPerJson.CouOfDom === undefined) {
            isValid = false;
        }
        else if(authPerJson.DescAccOccList.DescActOcc.length === 0){
            isValid = false;
        }

        return isValid;
    }

    const goNext = () => {
        storage.setIsAPEdited(isAPDtlsEdited);
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {  //from Preview
               // history.goBack();
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true'){  
                    if(isAPDtlsEdited){
                        if(hasShareholdersForm()) {
                            history.push(config.route.ShareholdersDetails);
                        }
                        else {
                            history.push(config.route.NSBizBankingService);
                        }
                    }
                    else {
                        history.goBack();
                    }
                }
                else {  //subsequent AP
                    history.goBack();
                }
            }
        }
        else { //not from Preview
            if(hasShareholdersForm()) {
                history.push(config.route.ShareholdersDetails);
            }
            else {
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true'){  
                    history.push(config.route.NSBizBankingService);
                }
                else {
                    history.push(config.route.NSDelegationDetails);
                }
            }
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const formatJsonParams = (data) => {
        let appDtlsArray = [];
     
        if(getLoginUserSeq() === '0') {  //first login user

            if(isAPDtlsEdited === false){
                if(Object.entries(appDtls0).length !== 0) appDtlsArray.push(appDtls0);
            }
           
            appDtlsArray.push(formatApplicantObj1(data));
            if(formatApplicantObj2(data) !==null) appDtlsArray.push(formatApplicantObj2(data));
            if(formatApplicantObj3(data) !==null) appDtlsArray.push(formatApplicantObj3(data));
        }
        else { //not first login user
            if(getLoginUserSeq() === '1') { // applicant 1
                if(formatApplicantObj1(data) !==null) appDtlsArray.push(formatApplicantObj1(data));
            }
            else if(getLoginUserSeq() === '2') {  // applicant 2
                if(formatApplicantObj2(data) !==null) appDtlsArray.push(formatApplicantObj2(data));
            } 
            else if(getLoginUserSeq() === '3') { // applicant 3
                if(formatApplicantObj3(data) !==null) appDtlsArray.push(formatApplicantObj3(data));
            }
        }

        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true'){
            setApplicantsWithShareholderPosition(appDtlsArray);  // to get how many Shareholders has added as Authorised

            if(isAPDtlsEdited === false) {
                if(Array.isArray(response.ApplicantDtls)) {
                    for(let k in response.ApplicantDtls) {
                        if(response.ApplicantDtls[k].Authorised === 'false'){
                            appDtlsArray.push(response.ApplicantDtls[k]);
                        }
                    }
                }
            }
        }
   
       
        let params = {
            CurrentUser:currentUser(),
            ApplicantDtls:appDtlsArray
        }
     
        return params;
    }


    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:getLoginUserSeq(),
            Order:getLoginUserOrder(),
            isAuthPerDtlsEdited: isAPDtlsEdited
        }
        return params;
    }

    //To know how many Shareholders added as AP
    const setApplicantsWithShareholderPosition = (applicantArray) => {
        let temp = [];
        for(let i in applicantArray) {
            const positionCode = helper.getDesignationbyIDNum(applicantArray[i].IDNum,holders)
           
            if(positionCode === pureSHPositionCode) {
                temp.push(applicantArray[i]);
            }
        }
      
        pureSHApplicants = temp;
    }

    const getNonFirstUserSeq = () => {
        if(!Array.isArray(response.ApplicantDtls)){ //check obj
            if(response.ApplicantDtls.IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                return response.ApplicantDtls.ApplicantSeq;
            }
        }
        else { //array
            for(let i in response.ApplicantDtls){
                if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                    return response.ApplicantDtls[i].ApplicantSeq;
                }
            }
        }
    }

    const getLoginUserOrder = () => {
        
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {  // first login person
            if(hasMyInfo) {  
                return '1';
            }
            else if(hasMyInfo2) {
                return '2';
            }
            else if(hasMyInfo3) {
                return '3';
            }
            else {
                return '0';
            }
        }
        else { // not first login person, get current login user seq from ApplicantDtls array
            return getNonFirstUserSeq();
        }
    }

    const getLoginUserSeq = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            return '0';  // first user, default return 0
        }
        else {// not first login person, get current login user seq from ApplicantDtls array
            return getNonFirstUserSeq();
        }
    }

    const hasShareholdersForm = () => {
        // compare number of Share holders and num of shareholder postion AP
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'false') {
            return false;
        }
        else if(pureSholders.length > pureSHApplicants.length) {
            return true;
        }
        else {
            return false;
        }
    }

    const occupationList1 = (data) => {
   
        let occList = [];
     
        if(data.DescActOcc11){
            occList.push(data.DescActOcc11.value);
        }
        if(data.DescActOcc21){
            occList.push(data.DescActOcc21.value);
        }
        if(data.DescActOcc31) {
            occList.push(data.DescActOcc31.value);
        }
      
        return occList;
    }

    const occupationList2 = (data) => {
        let occList = [];
     
        if(data.DescActOcc12){
            occList.push(data.DescActOcc12.value);
        }
        if(data.DescActOcc22){
            occList.push(data.DescActOcc22.value);
        }
        if(data.DescActOcc32) {
            occList.push(data.DescActOcc32.value);
        }

        return occList;
    }

    const occupationList3 = (data) => {
        let occList = [];
     
        if(data.DescActOcc13){
            occList.push(data.DescActOcc13.value);
        }
        if(data.DescActOcc23){
            occList.push(data.DescActOcc23.value);
        }
        if(data.DescActOcc33) {
            occList.push(data.DescActOcc33.value);
        }

        return occList;
    }

 

    const formatApplicantObj1 = (data) => {
        let ApplicantDtls1={};
        if(hasMyInfo) {
       
            PersWealthSG1 = PersWealthSG1 === null? 'Y':PersWealthSG1;
        
            ApplicantDtls1 = {
                Name: data.nameCbo1 !== undefined? data.nameCbo1.Name:'',   
                ApplicantSeq: authPer1,
                IDNum: data.nameCbo1 !==undefined? data.nameCbo1.IDNum:'',  
                Title: data.titleCbo1.value,
                MarStatus: data.marStatusCbo1.value,
                CouOfDom: data.counOfDomicileCbo1.value,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno1.trim(),
                EmailAdd: data.em1.trim(),

                MailAddrSameAsRes: MailAddrSameAsRes1? MailAddrSameAsRes1:'Y',
                MailAddType: 'D',//data.MailAddType1
                MailPostalCode: data.MailPostalCode1,
                MailBlkNo:data.MailBlkNo1,
                MailStreet:data.MailStreet1,
                MailFlrNum:data.MailFlrNum1,
                MailUnitNo:data.MailUnitNo1,
                MailBldName:data.MailBldName1,
                MailCountry:MailAddrSameAsRes1==='N'? appDetailsData.DefCountry.name:'',
                PersWealthSG: PersWealthSG1,
                PersWealthCou: {
                    SG: PersWealthSG1 === 'Y'?false: data.SG1,
                    BN: PersWealthSG1 === 'Y'?false: data.BN1,
                    MY: PersWealthSG1 === 'Y'?false: data.MY1,
                    CN: PersWealthSG1 === 'Y'?false: data.CN1,
                    ID: PersWealthSG1 === 'Y'?false: data.ID1,
                    IN: PersWealthSG1 === 'Y'?false: data.IN1,
                    OTH: PersWealthSG1 === 'Y'?false: data.OTH1,
                    PersWealthOTH:PersWealthSG1 === 'Y'? null: data.OTH1? data.PersWealthOTH1.value:null
                },
                DescAccOccList : {
                    DescActOcc:occupationList1(data)
                },
                Authorised:true,  
                SHSeq:'000' //shareholder seq
            }
        }
        else {
            ApplicantDtls1 = {
                Name: data.nameCbo1 !== undefined? data.nameCbo1.Name:'',   
                ApplicantSeq: authPer1,
                IDNum: data.nameCbo1 !==undefined? data.nameCbo1.IDNum:'',
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno1.trim(),
                EmailAdd: data.em1.trim(),
                Authorised:true, 
                SHSeq:'000' //shareholder seq
            }
        }

        return ApplicantDtls1;
    }

    const formatApplicantObj2 = (data) => {
        let ApplicantDtls2={};
        if(data.nameCbo2.Name === undefined){
            return null;
        }
        if(hasMyInfo2) {
            PersWealthSG2 = PersWealthSG2 === null? 'Y':PersWealthSG2
            ApplicantDtls2 = {
                Name: data.nameCbo2 !== undefined? data.nameCbo2.Name:'',   
                ApplicantSeq: authPer2,
                IDNum: data.nameCbo2 !==undefined? data.nameCbo2.IDNum:'',
                Title: data.titleCbo2.value,
                MarStatus: data.marStatusCbo2.value,
                CouOfDom: data.counOfDomicileCbo2.value,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno2.trim(),
                EmailAdd: data.em2.trim(),

                MailAddrSameAsRes:MailAddrSameAsRes2? MailAddrSameAsRes2:'Y',
                MailAddType:'D',//data.MailAddType2
                MailPostalCode: data.MailPostalCode2,
                MailBlkNo:data.MailBlkNo2,
                MailStreet:data.MailStreet2,
                MailFlrNum:data.MailFlrNum2,
                MailUnitNo:data.MailUnitNo2,
                MailBldName:data.MailBldName2,
                MailCountry: MailAddrSameAsRes2 ==='N'?appDetailsData.DefCountry.name:'',

                PersWealthSG: PersWealthSG2,
                PersWealthCou: {
                    SG: PersWealthSG2 === 'Y'? false: data.SG2,
                    BN: PersWealthSG2 === 'Y'? false:  data.BN2,
                    MY: PersWealthSG2 === 'Y'? false: data.MY2,
                    CN: PersWealthSG2 === 'Y'? false: data.CN2,
                    ID: PersWealthSG2 === 'Y'? false: data.ID2,
                    IN: PersWealthSG2 === 'Y'? false: data.IN2,
                    OTH: PersWealthSG2 === 'Y'? false: data.OTH2,
                    PersWealthOTH: PersWealthSG2 === 'Y'? null: data.OTH2? data.PersWealthOTH2.value:null
                },
                DescAccOccList : {
                    DescActOcc:occupationList2(data)
                },
                Authorised:true, 
                SHSeq:'000' //shareholder seq 
            }
        }
        else {
            ApplicantDtls2 = {
                Name: data.nameCbo2 !== undefined? data.nameCbo2.Name:'',   
                ApplicantSeq: authPer2,
                IDNum: data.nameCbo2 !==undefined? data.nameCbo2.IDNum:'',
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno2.trim(),
                EmailAdd: data.em2.trim(),
                Authorised:true, 
                SHSeq:'000' //shareholder seq
            }
        }

        return ApplicantDtls2;
    }

    const formatApplicantObj3 = (data) => {
        let ApplicantDtls3={};
        if(data.nameCbo3.Name === undefined) {
            
            return null;
        }
        if(hasMyInfo3) {
            PersWealthSG3 = PersWealthSG3 ===null? 'Y':PersWealthSG3;
            ApplicantDtls3= {
                Name: data.nameCbo3 !== undefined? data.nameCbo3.Name:'',   
                ApplicantSeq: authPer3,
                IDNum: data.nameCbo3 !==undefined? data.nameCbo3.IDNum:'',
                Title: data.titleCbo3.value,
                MarStatus: data.marStatusCbo3.value,
                CouOfDom: data.counOfDomicileCbo3.value,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno3.trim(),
                EmailAdd: data.em3.trim(),

                MailAddrSameAsRes: MailAddrSameAsRes3?MailAddrSameAsRes3:'Y',
                MailAddType:'D',//data.MailAddType3
                MailPostalCode: data.MailPostalCode3,
                MailBlkNo:data.MailBlkNo3,
                MailStreet:data.MailStreet3,
                MailFlrNum:data.MailFlrNum3,
                MailUnitNo:data.MailUnitNo3,
                MailBldName:data.MailBldName3,
                MailCountry: MailAddrSameAsRes3 === 'N'? appDetailsData.DefCountry.name:'',

                PersWealthSG: PersWealthSG3,
                PersWealthCou: {
                    SG: PersWealthSG3 ==='Y'? false: data.SG3,
                    BN: PersWealthSG3 ==='Y'? false: data.BN3,
                    MY: PersWealthSG3 ==='Y'? false: data.MY3,
                    CN: PersWealthSG3 ==='Y'? false: data.CN3,
                    ID: PersWealthSG3 ==='Y'? false: data.ID3,
                    IN: PersWealthSG3 ==='Y'? false: data.IN3,
                    OTH: PersWealthSG3 ==='Y'? false: data.OTH3,
                    PersWealthOTH: PersWealthSG3 ==='Y'? null: data.OTH3? data.PersWealthOTH3.value:null
                },
                DescAccOccList : {
                    DescActOcc:occupationList3(data)
                },
                Authorised:true, 
                SHSeq:'000' //shareholder seq 
            }
        }
        else {
            ApplicantDtls3 = {
                Name: data.nameCbo3 !== undefined? data.nameCbo3.Name:'',   
                ApplicantSeq: authPer3,
                IDNum: data.nameCbo3 !==undefined? data.nameCbo3.IDNum:'',
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno3.trim(),
                EmailAdd: data.em3.trim(),
                Authorised:true, 
                SHSeq:'000' //shareholder seq
            }
        }

        return ApplicantDtls3;
    }

    const isLoginUserPureShareholder = (data) => {
        const appDtlsMyInfo = data.ApplicantsDtlsMyInfo;
        let result = false;
        if(appDtlsMyInfo.isFirstUser === 'false') {
         
            if(Array.isArray(data.ApplicantDtls)) {
                let authPer = helper.getObjInArraybyIDNum(appDtlsMyInfo.IDNum,data.ApplicantDtls)
             
                if(authPer.Authorised === 'false') { // pure Share holder
                    result = true;
                }
                else {
                    result = false;
                }
            }
        }
   
        storage.setIsLoginUserShareholder(result);
        return result;
    }

    const isValidSubAPMyInfo = (data) => {
        let isValid = true;
        const appDtlsMyInfo = data.ApplicantsDtlsMyInfo;
 
        if(appDtlsMyInfo.isFirstUser === 'false') {
            let subAP = {
                myInfo:appDtlsMyInfo
            }
            if(!validateMyInfoMandatoryFields(subAP)){
                showErrMsg(config.error.MyInfo.MissingDataSubAP);
                isValid = false;
            }
            else if(!validateMyInfoDOBFormat(subAP)) {
                showErrMsg(config.error.MyInfo.InvalidDOBSubAP);
                isValid = false;
            }
        }

        return isValid;
    }

    const isValidNumOfApplicants = (apptDtlsArray) => {
        let isValid = true;
          let tempHolders = [], tempApplicants=[];
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true'){
          
            for(let i in holders) {
                if(!passDesignation(holders[i].Designation)) {
                    tempHolders.push(holders[i]);
                }
            }
            
            for(let j in apptDtlsArray) {
                let designation = helper.getDesignationbyIDNum(apptDtlsArray[j].IDNum,holders);
                if(!passDesignation(designation)){
                    tempApplicants.push(apptDtlsArray[j]);
                }
            }
         
            if(tempApplicants < tempHolders) {
                isValid = false;
            }
        }

        return isValid;
    }

    //check upon SME CASA Requirements_Error message for AP v2.1.docx
    const passDesignation = (designation) => {
        let pass = true;
        if(designation === '26') {  
            pass = true;
        } 
        else if(designation === '27') {
            pass = true;
        }
        else if(designation === '28') {
            pass = true;
        }
        else if(designation === '30') {
            pass = true;
        }
        else if(designation === '10') {
            pass = true;
        }
        else if(designation === '15') {
            pass = true;
        }
        else if(designation === '17') {
            pass = true;
        }
        else if(designation === '18') {
            pass = true;
        }
        else if(designation === '19') {
            pass = true;
        }
        else if(designation === '1') {
            pass = true;
        }
        else if(designation === '2') {
            pass = true;
        }
        else if(designation === '3') {
            pass = true;
        }
        else if(designation === '4') {
            pass = true;
        }
        else if(designation === '5') {
            pass = true;
        }
        else if(designation === '6') {
            pass = true;
        }
        else if(designation === '9') {
            pass = true;
        }
        else if(designation === '20') {
            pass = true;
        }
        else if(designation === '21') {
            pass = true;
        }
        else if(designation === '000') {
            pass = true;
        }
        else {
            pass = false;
        }
      

        return pass; 
    }

    const validateMyInfoDOBFormat = (appDtls,title) => {
        let isValid = true;
        if(appDtls.myInfo.DOB !== null || appDtls.myInfo.DOB !== "" || appDtls.myInfo.DOB !== undefined){
            if(dobRegex.test(appDtls.myInfo.DOB) === false) {
                //console.log('invalid DOB format')
                isValid = false;
            }
        }
        return isValid;
    }


    const validateMyInfoMandatoryFields = (appDtls,title) => {
 
        let isValid = true;
        
        if(appDtls.myInfo.IDNum === null || appDtls.myInfo.IDNum === "" || appDtls.myInfo.IDNum === undefined) {
            //console.log('invalid IDNum')
            isValid = false;
        }
        else if(appDtls.myInfo.DOB === null || appDtls.myInfo.DOB === "" || appDtls.myInfo.DOB === undefined) {
            //console.log('invalid DOB')
            isValid = false;
        }
        else if(appDtls.myInfo.Gender === null || appDtls.myInfo.Gender === "" || appDtls.myInfo.Gender === undefined) {
            //console.log('invalid Gender')
            isValid = false;
        }
        else if(appDtls.myInfo.Race === null || appDtls.myInfo.Race === "" || appDtls.myInfo.Race === undefined) {
            //console.log('invalid Race')
            isValid = false;
        }
        else if(appDtls.myInfo.Nationality === null || appDtls.myInfo.Nationality === "" || appDtls.myInfo.Nationality === undefined) {
            //console.log('invalid Nationality')
            isValid = false;
        }
        else if(appDtls.myInfo.CnOfBirth === null || appDtls.myInfo.CnOfBirth === "" || appDtls.myInfo.CnOfBirth === undefined) {
            //console.log('invalid CnOfBirth')
            isValid = false;
        }
        else if(appDtls.myInfo.ResStatus === null || appDtls.myInfo.ResStatus === "" || appDtls.myInfo.ResStatus === undefined) {
            //console.log('invalid ResStatus')
            isValid = false;
        }
        else if(appDtls.myInfo.Designation === null || appDtls.myInfo.Designation === "" || appDtls.myInfo.Designation === undefined) {
            //console.log('invalid Designation')
            isValid = false;  
        }
        else if(appDtls.myInfo.ResAddType === null || appDtls.myInfo.ResAddType === "" || appDtls.myInfo.ResAddType === undefined) {
            isValid = false;  
        }
        else if(appDtls.myInfo.ResAddType === config.addTypeLocal) {
            //console.log('addTypeLocal')
            if(appDtls.myInfo.ResPostalCode === null || appDtls.myInfo.ResPostalCode === "" || appDtls.myInfo.ResPostalCode === undefined) {
                //console.log('invalid ResPostalCode')
                isValid = false;
            }
            else if(appDtls.myInfo.ResBlkNo === null || appDtls.myInfo.ResBlkNo === "" || appDtls.myInfo.ResBlkNo === undefined) {
                //console.log('invalid ResBlkNo')
                isValid = false;
            }
            else if(appDtls.myInfo.ResStreet === null || appDtls.myInfo.ResStreet === "" || appDtls.myInfo.ResStreet === undefined) {
                //console.log('invalid ResStreet')
                isValid = false;
            }
        }
        else if(appDtls.myInfo.ResAddType === config.addTypeForeign || appDtls.myInfo.ResAddType === config.addTypeLocalUnformat) {
            //console.log('addTypeForeign')
            if(appDtls.myInfo.ResAddLine1 === null || appDtls.myInfo.ResAddLine1 === "" || appDtls.myInfo.ResAddLine1 === undefined) {
                //console.log('invalid ResAddLine1')
                isValid = false;
            }
            else if(appDtls.myInfo.ResAddLine2 === null || appDtls.myInfo.ResAddLine2 === "" || appDtls.myInfo.ResAddLine2 === undefined) {
                //console.log('invalid ResAddLine2')
                isValid = false;
            }
        }
       
        return isValid;
    }

    const getStateId = () => {
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        if(stateId) {
            storage.setStateId(stateId);
        }
    }
    
    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                
                if(res.data.model.fields.Data === "Empty") {  //MyInfo user click close, route to Product page.
                    setIsLoading(false);
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }

                if(!isValidSubAPMyInfo(res.data.model.fields.request)){
                    // setIsLoading(false);
                    // return;
                }

                if(isLoginUserPureShareholder(res.data.model.fields.request)){
                    setIsLoading(false);
                    history.push(config.route.ShareholdersDetails);
                    return;
                }

                bindFormData(res.data.model.fields.request);
                checkCompType(res.data.model.fields.request)  //to use for upload details page routing
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
           
            setIsLoading(false);
            showErrMsg('Error: Get data failed.');
        })
    }

    

    const disableRemoveAndAddBtn = (loginUser) => {
        if(loginUser.isFirstUser === 'true') {
            setIsSaveDone(false);
        }
        else {
            setIsSaveDone(true);
        }
    }

    const bindFormData = (resData) => {
        const data = resData.ApplicantDtls;  //to check for first time or not
        const myInfoData = resData.ApplicantsDtlsMyInfo;  // Login user 
        try{
            setResponse(resData);
            createHolders(resData);
            disableRemoveAndAddBtn(myInfoData);  // Remove and Add btns: true to disable, false to enable

            if(data) {  //not first time
                if(data.length !== 0) {
                    bindAppDtlsFormData(resData);
                }
            }
            else {
                bindFirstTime(myInfoData);
            }
        }
        catch(ex) {
            //  console.log('bindFormData ',ex);
        }

        setIsLoading(false);
    }

    const bindFirstTime = (myInfoData) => {
 
         let obj = {
            myInfo:myInfoData,
            occupList:[],
            allowEdit:true,
            contactDtlEdit:true
         }

         setApplicantDetails(obj);  
         setApplicantDetails2(obj);
         setApplicantDetails3(obj);
    }


    const bindAppDtlsFormData = (data) => {
        let data1 , data2 , data3;
        let occupArray1=[], occupArray2=[], occupArray3=[],holdersDtls = [];
        if(!Array.isArray(data.ApplicantDtls)) {
            data1 = data.ApplicantDtls;
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].Authorised === undefined || data.ApplicantDtls[i].Authorised === 'true') {
                    if(data.ApplicantDtls[i].ApplicantSeq === authPer1) data1= data.ApplicantDtls[i];
                    if(data.ApplicantDtls[i].ApplicantSeq === authPer2) data2 = data.ApplicantDtls[i];
                    if(data.ApplicantDtls[i].ApplicantSeq === authPer3) data3 = data.ApplicantDtls[i];
                    if(data.ApplicantDtls[i].ApplicantSeq === authPer0) setAppDtls0(data.ApplicantDtls[i]);
                }
            }
        }

   
        holdersDtls = getHoldersDtls(data);
       
        if(data1){
          
            occupArray1 = setOccListArray(data1,authPer1);
            MailAddrSameAsRes1 = data1.MailAddrSameAsRes !== null? data1.MailAddrSameAsRes:'Y';
            PersWealthSG1 = data1.PersWealthSG && data1.PersWealthSG !==null? data1.PersWealthSG:'Y';
            setSelectedName(data1.IDNum? helper.getObjInArraybyIDNum(data1.IDNum,holdersDtls):'');
            setHasMyInfo1Value(data1,data);
            setApplicantDetails({
                myInfo: getLoginUserMyInfoData(data1,data),
                occupList:occupArray1,
                allowEdit:checkAllowEdit(data1,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo)
            })
            setIsExpendAuth1(expendLoginUser(data1,data.ApplicantsDtlsMyInfo));
        }
   
        if(data2){ 
          
            occupArray2 = setOccListArray(data2,authPer2);
            MailAddrSameAsRes2 = data2.MailAddrSameAsRes !==null? data2.MailAddrSameAsRes:'Y';
            PersWealthSG2 =data2.PersWealthSG && data2.PersWealthSG !==null? data2.PersWealthSG:'Y';
            setSelectedName2(data2.IDNum? helper.getObjInArraybyIDNum(data2.IDNum,holdersDtls):'')
            setHasMyInfo2Value(data2,data);
            setApplicantDetails2({
                myInfo:getLoginUserMyInfoData(data2,data),
                occupList:occupArray2,
                allowEdit:checkAllowEdit(data2,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo)
            })
            showAuthPerson2 = data2.IDNum? true:false;
            setShowAddBtn(!showAuthPerson2);
            setIsExpendAuth2(expendLoginUser(data2,data.ApplicantsDtlsMyInfo));
        }

 
        if(data3){
        
            occupArray3 = setOccListArray(data3,authPer3);
            MailAddrSameAsRes3 = data3.MailAddrSameAsRes !==null? data3.MailAddrSameAsRes:'Y';
            PersWealthSG3 =data3.PersWealthSG && data3.PersWealthSG !==null? data3.PersWealthSG:'Y';
            setSelectedName3(data3.IDNum? helper.getObjInArraybyIDNum(data3.IDNum,holdersDtls):'')
            setHasMyInfo3Value(data3,data);
            setApplicantDetails3({
                myInfo:getLoginUserMyInfoData(data3,data),
                occupList:occupArray3,
                allowEdit:checkAllowEdit(data3,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo)
            })
            showAuthPerson3 = data3.IDNum? true:false;
            setShowAddBtn2(!showAuthPerson3); //hide Add btn if auth person2 is true
            setIsExpendAuth3(expendLoginUser(data3,data.ApplicantsDtlsMyInfo));
        }
        
        setInitFormData({
            nameCbo1:data1.IDNum? helper.getObjInArraybyIDNum(data1.IDNum,holdersDtls):'',
            titleCbo1:data1.Title? helper.getObjInArray(data1.Title,titles):'',
            marStatusCbo1:data1.MarStatus? helper.getObjInArray(data1.MarStatus,marStatusArray):'',
            counOfDomicileCbo1:data1.CouOfDom? helper.getObjInArray(data1.CouOfDom,countriesDomicile):'',
            mno1:data1.MobileNo && data1.MobileNo!==null? data1.MobileNo:'',
            em1:data1.EmailAdd && data1.EmailAdd !==null? data1.EmailAdd:'',

            MailAddType1:config.addTypeLocal,
            MailBlkNo1: data1.MailBlkNo && data1.MailBlkNo !== null? data1.MailBlkNo:'',
            MailStreet1: data1.MailStreet && data1.MailStreet !== null? data1.MailStreet:'',
            MailFlrNum1: data1.MailFlrNum && data1.MailFlrNum !==null? data1.MailFlrNum:'',
            MailUnitNo1: data1.MailUnitNo && data1.MailUnitNo !==null? data1.MailUnitNo:'',
            MailBldName1: data1.MailBldName && data1.MailBldName !==null? data1.MailBldName:'',
            MailPostalCode1: data1.MailPostalCode && data1.MailPostalCode !==null? data1.MailPostalCode:'',
            MailCountry1:appDetailsData.DefCountry.label,
       
            DescActOcc11:helper.getObjInArray(occupArray1[0],occupations),
            DescActOcc21:occupArray1[1]? helper.getObjInArray(occupArray1[1],occupations):'',
            DescActOcc31:occupArray1[2]? helper.getObjInArray(occupArray1[2],occupations):'',
 
            SG1: data1.PersWealthCou && data1.PersWealthCou.SG === 'true'?true:false,
            BN1: data1.PersWealthCou && data1.PersWealthCou.BN === 'true'?true:false,
            MY1: data1.PersWealthCou && data1.PersWealthCou.MY === 'true'?true:false,
            CN1: data1.PersWealthCou && data1.PersWealthCou.CN === 'true'?true:false,
            ID1: data1.PersWealthCou && data1.PersWealthCou.ID === 'true'?true:false,
            IN1: data1.PersWealthCou && data1.PersWealthCou.IN === 'true'?true:false,
            OTH1: data1.PersWealthCou && data1.PersWealthCou.OTH === 'true'?true:false,
            PersWealthOTH1: data1.PersWealthCou && data1.PersWealthCou.OTH === 'true'? helper.getObjInArray(data1.PersWealthCou.PersWealthOTH,countriesRisk):'',

            nameCbo2:data2 && data2.IDNum? helper.getObjInArraybyIDNum(data2.IDNum,holdersDtls):'',
            mno2:data2 && data2.MobileNo && data2.MobileNo!==null? data2.MobileNo:'',
            em2:data2 && data2.EmailAdd && data2.EmailAdd !==null? data2.EmailAdd:'',
            titleCbo2:data2 && data2.Title && data2.Title !==null? helper.getObjInArray(data2.Title,titles):'',
            marStatusCbo2:data2 && data2.MarStatus && data2.MarStatus !==null? helper.getObjInArray(data2.MarStatus,marStatusArray):'',
            counOfDomicileCbo2:data2 && data2.CouOfDom && data2.CouOfDom !==null? helper.getObjInArray(data2.CouOfDom,countriesDomicile):'',
            MailAddType2:config.addTypeLocal,
            MailBlkNo2: data2 && data2.MailBlkNo && data2.MailBlkNo !== null? data2.MailBlkNo:'',
            MailStreet2: data2 && data2.MailStreet && data2.MailStreet !== null? data2.MailStreet:'',
            MailFlrNum2: data2 && data2.MailFlrNum && data2.MailFlrNum !==null? data2.MailFlrNum:'',
            MailUnitNo2: data2 && data2.MailUnitNo && data2.MailUnitNo !==null? data2.MailUnitNo:'',
            MailBldName2: data2 && data2.MailBldName && data2.MailBldName !==null? data2.MailBldName:'',
            MailPostalCode2:data2 && data2.MailPostalCode && data2.MailPostalCode !==null? data2.MailPostalCode:'',
            MailCountry2:appDetailsData.DefCountry.label,

            DescActOcc12:occupArray2[0]? helper.getObjInArray(occupArray2[0],occupations):'',
            DescActOcc22:occupArray2[1]? helper.getObjInArray(occupArray2[1],occupations):'',
            DescActOcc32:occupArray2[2]? helper.getObjInArray(occupArray2[2],occupations):'',

            SG2: data2 && data2.PersWealthCou && data2.PersWealthCou.SG === 'true'?true:false,
            BN2: data2 && data2.PersWealthCou && data2.PersWealthCou.BN === 'true'?true:false,
            MY2: data2 && data2.PersWealthCou && data2.PersWealthCou.MY === 'true'?true:false,
            CN2: data2 && data2.PersWealthCou && data2.PersWealthCou.CN === 'true'?true:false,
            ID2: data2 && data2.PersWealthCou && data2.PersWealthCou.ID === 'true'?true:false,
            IN2: data2 && data2.PersWealthCou && data2.PersWealthCou.IN === 'true'?true:false,
            OTH2: data2 && data2.PersWealthCou && data2.PersWealthCou.OTH === 'true'?true:false,
            PersWealthOTH2: data2 && data2.PersWealthCou && data2.PersWealthCou.OTH === 'true'? helper.getObjInArray(data2.PersWealthCou.PersWealthOTH,countriesRisk):'',

            nameCbo3:data3 && data3.IDNum? helper.getObjInArraybyIDNum(data3.IDNum,holdersDtls):'',
            mno3:data3 && data3.MobileNo && data3.MobileNo!==null? data3.MobileNo:'',
            em3:data3 && data3.EmailAdd && data3.EmailAdd !==null? data3.EmailAdd:'',
            titleCbo3:data3 && data3.Title? helper.getObjInArray(data3.Title,titles):'',
            marStatusCbo3:data3 && data3.MarStatus? helper.getObjInArray(data3.MarStatus,marStatusArray):'',
            counOfDomicileCbo3:data3 && data3.CouOfDom? helper.getObjInArray(data3.CouOfDom,countriesDomicile):'',
            MailAddType3:config.addTypeLocal,
            MailBlkNo3: data3 && data3.MailBlkNo && data3.MailBlkNo !== null? data3.MailBlkNo:'',
            MailStreet3:data3 && data3.MailStreet && data3.MailStreet !== null? data3.MailStreet:'',
            MailFlrNum3: data3 && data3.MailFlrNum && data3.MailFlrNum !==null? data3.MailFlrNum:'',
            MailUnitNo3:data3 &&  data3.MailUnitNo && data3.MailUnitNo !==null? data3.MailUnitNo:'',
            MailBldName3:data3 &&  data3.MailBldName && data3.MailBldName !==null? data3.MailBldName:'',
            MailPostalCode3:data3 && data3.MailPostalCode && data3.MailPostalCode !==null? data3.MailPostalCode:'',
            MailCountry3:appDetailsData.DefCountry.label,

            DescActOcc13:occupArray3[0]? helper.getObjInArray(occupArray3[0],occupations):'',
            DescActOcc23:occupArray3[1]? helper.getObjInArray(occupArray3[1],occupations):'',
            DescActOcc33:occupArray3[2]? helper.getObjInArray(occupArray3[2],occupations):'',
 
            SG3: data3 && data3.PersWealthCou && data3.PersWealthCou.SG === 'true'?true:false,
            BN3: data3 && data3.PersWealthCou && data3.PersWealthCou.BN === 'true'?true:false,
            MY3: data3 && data3.PersWealthCou && data3.PersWealthCou.MY === 'true'?true:false,
            CN3: data3 && data3.PersWealthCou && data3.PersWealthCou.CN === 'true'?true:false,
            ID3: data3 && data3.PersWealthCou && data3.PersWealthCou.ID === 'true'?true:false,
            IN3: data3 &&  data3.PersWealthCou && data3.PersWealthCou.IN === 'true'?true:false,
            OTH3: data3 && data3.PersWealthCou && data3.PersWealthCou.OTH === 'true'?true:false,
            PersWealthOTH3:data3 && data3.PersWealthCou && data3.PersWealthCou.OTH === 'true'? helper.getObjInArray(data3.PersWealthCou.PersWealthOTH,countriesRisk):''
        })
     
    } 

    const goToErrorPage = (errType) => {
        props.history.push(config.route.InvalidEntity,{errType:errType});
    }

    const setHasMyInfo1Value = (data,resData) => {
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            setHasMyInfo(true);
        }
        else if(resData.SubmittedApplicants.Applicant1 === 'true') {
            setHasMyInfo(true);
        }
        else {
            setHasMyInfo(false);
        }
    }

    const setHasMyInfo2Value = (data,resData) => {
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            setHasMyInfo2(true);
        }
        else if(resData.SubmittedApplicants.Applicant2 === 'true') {
            setHasMyInfo2(true);
        }
        else {
            setHasMyInfo2(false);
        }
    }

    const setHasMyInfo3Value = (data,resData) => {
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            setHasMyInfo3(true);
        }
        else if(resData.SubmittedApplicants.Applicant3 === 'true') {
            setHasMyInfo3(true);
        }
        else {
            setHasMyInfo3(false);
        }
    }

    const getLoginUserMyInfoData = (authDtls,resData) => {
        if(authDtls.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){ // get the login's person
            if(authDtls.DescAccOccList === undefined) {  
                return resData.ApplicantsDtlsMyInfo;
            }
            else {
                return authDtls;
            }
        }
        else {
            return authDtls;
        }
    }

    const setOccListArray = (data,seq) => {
 
        let occArray = [];
        if(data.DescAccOccList !== undefined && data.DescAccOccList !== null){
            if(!Array.isArray(data.DescAccOccList.DescActOcc)) {
                occArray.push(data.DescAccOccList.DescActOcc);
            }
            else {
             
                occArray = data.DescAccOccList.DescActOcc;
            }
        }
  
        return occArray;
    }

    const getHolders2 = () => {
        let array = helper.filterArrayByName(holders,selectedName.Name);
  
        return array;
    }

    const getHolders3 = () => {
        let tempArray = helper.filterArrayByName(holders,selectedName.Name);
        let array = helper.filterArrayByName(tempArray,selectedName2.Name);
      
        return array;
    }

    const onAuthPersonRdoChange = (e, id) => {
  
        if(id === 'MailAddrSameAsRes1') {
            MailAddrSameAsRes1 = e.value;
        }
        else if(id === 'MailAddrSameAsRes2') {
            MailAddrSameAsRes2 = e.value;
        }
        else if(id === 'MailAddrSameAsRes3') {
           
            MailAddrSameAsRes3 = e.value;
        }
        else if(id === 'PersWealthSG1') {
            PersWealthSG1 = e.value;
        }
        else if(id === 'PersWealthSG2') {
            PersWealthSG2 = e.value;
        }
        else if(id === 'PersWealthSG3') {
            PersWealthSG3 = e.value;
        }
    }

    const checkAllowEdit = (authPerson,loginPerson) => {
 
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else if(authPerson.IDNum === loginPerson.IDNum) {
            return true;
        }
        else {
            return false;
        }
    }

    const checkContactDtlsEdit = (loginPerson) => {
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const expendLoginUser = (authPerson,loginPerson) => {
        if(authPerson.IDNum === loginPerson.IDNum) {
            return true;
        }
        return false;
    }

    const validatePersWealthCnty = (fProps,authPerSeq,persWealthSG) =>{
 
        if(persWealthSG === 'Y' || persWealthSG === undefined) {
            return true;   
        } 
        else {
            let params = {
                SG: fProps.valueGetter('SG'+authPerSeq),
                BN: fProps.valueGetter('BN'+authPerSeq),
                MY: fProps.valueGetter('MY'+authPerSeq),
                CN: fProps.valueGetter('CN'+authPerSeq),
                ID: fProps.valueGetter('ID'+authPerSeq),
                IN: fProps.valueGetter('IN'+authPerSeq),
                OTH: fProps.valueGetter('OTH'+authPerSeq)
            }
       
            return helper.validateNoOfCheckedBox(params,1,5);
        }
    }

    const setPersWealthCntyChkboxesToDefault = (fProps,authPerSeq) => {
        fProps.onChange('SG'+authPerSeq, { value: false });
        fProps.onChange('BN'+authPerSeq, { value: false });
        fProps.onChange('MY'+authPerSeq, { value: false });
        fProps.onChange('ID'+authPerSeq, { value: false });
        fProps.onChange('IN'+authPerSeq, { value: false });
        fProps.onChange('OTH'+authPerSeq, { value: false });
        fProps.onChange('PersWealthOTH2', { value: '' });
    }
    
    if(isLoading) {
        return(
          <Loading />
        )
    }

    return(
        <div className="container-fluid">
         <SubHeader />
         <FormContainer>
                <Form onSubmitClick={handleSubmit} 
                    initialValues={initFormData}
                    key={JSON.stringify(initFormData)}
                    render={(formRenderProps)=>(
                    <FormElement>
                        <fieldset>
                            <Field component={FormTitleTooltip} id={appDetailsData.formContainerTitle.T1} name={appDetailsData.formContainerTitle.T1.name} 
                                tooltipPosition={'right'} tooltipAchor={'target'}   
                                tooltipTitle={appDetailsData.tooltipText.T1} />
 
                            <div className="row around-xs inputPairSubTitle elementVisible">
                                <div className="col-xs-12col-sm-12 col-md-12 col-lg-12">
                                    <div id={appDetailsData.formContainerTitle.T1Desp}>{appDetailsData.formContainerTitle.T1Desp.name}</div>
                                </div>
                            </div>
                                
                            <Field component={CusFormSectionLabel} 
                                leftLabelId={'lblAuthPer1'} leftLabelName={appDetailsData.label.authPer+' 1'} 
                                hasAuthUser={selectedName.Name? true:false}
                                doneMyInfo={hasMyInfo}
                                id={'AuthPer1'} name={selectedName.Name}
                                isExpend={isExpendAuth1} 
                                    onClick={() =>{
                                        if(isExpendAuth1){
                                            setIsExpendAuth1(false);
                                        }
                                        else {
                                            setIsExpendAuth1(true);
                                        } 
                            }} />
                            {isExpendAuth1 &&  
                            <div>
                            <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.nameDDL.lblname}</div>
                                </div>
                                {hasMyInfo?
                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }} onClick={onShowDetails}> 
                                    {showDetails? 
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Hide Details 
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                                        </span> :
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Show Details  
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                                        </span> }
                                    </div>
                                </div> :   
                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                </div>}
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                    <Field component={FormComboBox} 
                                        leftLabelId={'lblnameCbo'} leftLabelName={appDetailsData.label.n}
                                        id={'nameCbo'+authPer1} name={'nameCbo'+authPer1}
                                        textField={'Name'} 
                                        data={holders}
                                        disabled={isSaveDone}
                                        placeholder={'Please select'} 
                                        validator={reqDDLValidator} 
                                        onChange={(e)=> {
                                            if(e.value === null){
                                                return;
                                            }
                                            if(selectedName2.IDNum !== undefined && e.value.IDNum === selectedName2.IDNum) {
                                                showErrMsg('Oops! Duplicate names found. Do remove one of the duplicate names and re-try.');
                                                formRenderProps.onChange('nameCbo'+authPer1,{ value: selectedName })
                                                return;
                                            }
                                            if(selectedName3.IDNum !== undefined && e.value.IDNum === selectedName3.IDNum) {
                                                showErrMsg('Oops! Duplicate names found. Do remove one of the duplicate names and re-try.');
                                                formRenderProps.onChange('nameCbo'+authPer1,{ value: selectedName })
                                                return;
                                            }
                                            
                                            setSelectedName(e.value);
                                            setIsAPDtlsEdited(true);
                                            setDisplay(true);
                                            if(e.value.IDNum === response.ApplicantsDtlsMyInfo.IDNum){
                                                let obj = {
                                                    myInfo:response.ApplicantsDtlsMyInfo,
                                                    occupList:[],
                                                    allowEdit:true,
                                                    contactDtlEdit:true
                                                }
                                                setApplicantDetails(obj);  

                                                setHasMyInfo(true);
                                                if(response.ApplicantsDtlsMyInfo.MarStatus !==null){
                                                    formRenderProps.onChange('marStatusCbo'+authPer1, { value: helper.getObjInArray(response.ApplicantsDtlsMyInfo.MarStatus,marStatusArray) });
                                                }
                                            }
                                            else{
                                                setHasMyInfo(false);
                                            }
                                            formRenderProps.onChange('mno'+authPer1, { value: '' });
                                            formRenderProps.onChange('em'+authPer1, { value: '' });
                                        }}
                                        /> 
                                    </div>
                                    </div>
                                </div>
                            </FieldWrapper> 

                            {Object.entries(selectedName).length !== 0 &&  
                            <AuthPerson applicantDetails={applicantDetails} showDetails={showDetails} formRenderProps={formRenderProps}
                                hasMyInfo={hasMyInfo} seq={authPer1} holders={holders}
                                onRdoChange={onAuthPersonRdoChange}
                                isPureSH={false}
                                showErrMsg={(msg) => {showErrMsg(msg)}} >
                            </AuthPerson>} 
                            {showAddBtn&& <CusAddBtn id={'AddBtn1'} label={appDetailsData.label.addAuthPerson} disabled={isSaveDone}
                                onClick={() => {
                                    if(formRenderProps.valid) {
                                        if(!validatePersWealthCnty(formRenderProps,authPer1,PersWealthSG1)) {
                                            showErrMsg(appDetailsData.label.ctrySourceWealth+": "+config.error.SelectChk5);
                                        }
                                        else {
                                            setShowAddBtn(false);
                                            setIsAPDtlsEdited(true);
                                        }
                                    }
                                    else {
                                        showErrMsg('Input the blank fields');
                                    }
                                }} /> }
                            </div>}
                         
                            {!showAddBtn && <div>
                            <Field component={CusFormSectionLabel} 
                                leftLabelId={'lblAuthPer2'} 
                                leftLabelName={appDetailsData.label.authPer+' '+authPer2} 
                                hasAuthUser={selectedName2.Name? true:false}
                                doneMyInfo={hasMyInfo2}
                                id={'AuthPer2'} name={selectedName2.Name}
                                isExpend={isExpendAuth2} 
                                    onClick={() =>{
                                        if(isExpendAuth2){
                                            setIsExpendAuth2(false);
                                        }
                                        else {
                                            setIsExpendAuth2(true);
                                        }
                                }} />

                            {isExpendAuth2 && <div>
                            {showAddBtn2 &&
                            <CusRemoveBtn id={'RemoveBtn1'} label={'REMOVE'} disabled={isSaveDone}
                                onClick={() => {
                                setIsAPDtlsEdited(true);
                                MailAddrSameAsRes2 = 'Y';
                                PersWealthSG2 = 'Y';
                                showAuthPerson2 = false;
                                setShowAddBtn(true);
                                setSelectedName2({});
                                setHasMyInfo2(false);
                                formRenderProps.onChange('nameCbo2', { value: '' });
                                formRenderProps.onChange('mno2', { value: '' });
                                formRenderProps.onChange('em2', { value: '' });
                                formRenderProps.onChange('titleCbo2', { value: '' });
                                formRenderProps.onChange('marStatusCbo2', { value: '' });
                                formRenderProps.onChange('counOfDomicileCbo2', { value: '' });
                                formRenderProps.onChange('MailAddType2', { value: '' });
                                formRenderProps.onChange('MailBlkNo2', { value: '' });
                                formRenderProps.onChange('MailStreet2', { value: '' });
                                formRenderProps.onChange('MailFlrNum2', { value: '' });
                                formRenderProps.onChange('MailUnitNo2', { value: '' });
                                formRenderProps.onChange('MailBldName2', { value: '' });
                                formRenderProps.onChange('MailPostalCode2', { value: '' });
                                formRenderProps.onChange('MailCountry2', { value: appDetailsData.DefCountry.label });
                                formRenderProps.onChange('DescActOcc12', { value: '' });
                                formRenderProps.onChange('DescActOcc22', { value: '' });
                                formRenderProps.onChange('DescActOcc32', { value: '' });
                                formRenderProps.onChange('SG2', { value: false });
                                formRenderProps.onChange('BN2', { value: false });
                                formRenderProps.onChange('MY2', { value: false });
                                formRenderProps.onChange('ID2', { value: false });
                                formRenderProps.onChange('IN2', { value: false });
                                formRenderProps.onChange('OTH2', { value: false });
                                formRenderProps.onChange('PersWealthOTH2', { value: '' });
                            }}/>}
                       
                            <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.nameDDL.lblname}</div>
                                </div>
                                {hasMyInfo2?
                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }} onClick={onShowDetails}> 
                                    {showDetails? 
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Hide Details 
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                                        </span> :
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Show Details  
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                                        </span> }
                                    </div>
                                </div> :   
                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                </div>}
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                    <Field id={'nameCbo'+authPer2} name={'nameCbo'+authPer2} 
                                        component={FormComboBox}
                                        textField={'Name'} clearButton={false}
                                        data={getHolders2()}
                                        placeholder={'Please select'}
                                        disabled={isSaveDone}
                                        validator={requiredValidator}
                                        onChange={(e) => {
                                            if(e.value === null){
                                                return;
                                            }
                                            if(selectedName3.IDNum !== undefined && e.value.IDNum === selectedName3.IDNum) {
                                                showErrMsg('Oops! Duplicate names found. Do remove one of the duplicate names and re-try.');
                                                formRenderProps.onChange('nameCbo'+authPer2,{ value: selectedName2 })
                                                return;
                                            }
                                        
                                            showAuthPerson2 = true;
                                            setSelectedName2(e.value);
                                            setIsAPDtlsEdited(true);
                                            if(e.value.IDNum === response.ApplicantsDtlsMyInfo.IDNum){
                                                setHasMyInfo2(true);
                                                setIsSaveDone(false);
                                                let obj = {
                                                    myInfo:response.ApplicantsDtlsMyInfo,
                                                    occupList:[],
                                                    allowEdit:true,
                                                    contactDtlEdit:true
                                                }
                                                setApplicantDetails2(obj);
                                                if(response.ApplicantsDtlsMyInfo.MarStatus !== null){
                                                    formRenderProps.onChange('marStatusCbo'+authPer2, { value: helper.getObjInArray(response.ApplicantsDtlsMyInfo.MarStatus,marStatusArray) });
                                                }
                                            }
                                            else{
                                                setHasMyInfo2(false);
                                            }
                                            formRenderProps.onChange('mno'+authPer2, { value: '' });
                                            formRenderProps.onChange('em'+authPer2, { value: '' });
                                            formRenderProps.onChange('titleCbo'+authPer2, { value: '' });
                                            formRenderProps.onChange('marStatusCbo'+authPer2, { value: '' });
                                            formRenderProps.onChange('counOfDomicileCbo'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailAddType'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailBlkNo'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailStreet'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailFlrNum'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailUnitNo'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailBldName'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailPostalCode'+authPer2, { value: '' });
                                            formRenderProps.onChange('MailCountry'+authPer2, { value: appDetailsData.DefCountry.label });
                                            formRenderProps.onChange('DescActOcc1'+authPer2, { value: '' });
                                            formRenderProps.onChange('DescActOcc2'+authPer2, { value: '' });
                                            formRenderProps.onChange('DescActOcc3'+authPer2, { value: '' });
                                            formRenderProps.onChange('SG'+authPer2, { value: false });
                                            formRenderProps.onChange('BN'+authPer2, { value: false });
                                            formRenderProps.onChange('MY'+authPer2, { value: false });
                                            formRenderProps.onChange('ID'+authPer2, { value: false });
                                            formRenderProps.onChange('IN'+authPer2, { value: false });
                                            formRenderProps.onChange('OTH'+authPer2, { value: false });
                                            formRenderProps.onChange('PersWealthOTH'+authPer2, { value: '' });
                                        }} /> 
                                    </div>
                                    </div>
                                </div>
                                {showAuthPerson2 &&
                                <div>
                                    <AuthPerson applicantDetails={applicantDetails2} showDetails={showDetails}
                                     hasMyInfo={hasMyInfo2} seq={authPer2} holders={holders}
                                     formRenderProps={formRenderProps}
                                     isPureSH={false}
                                     onRdoChange={onAuthPersonRdoChange}
                                     showErrMsg={(msg) => {showErrMsg(msg)}}
                                     ></AuthPerson>

                                    {showAddBtn2 &&
                                    <CusAddBtn id={'AddBtn2'} label={appDetailsData.label.addAuthPerson} disabled={isSaveDone}
                                        onClick={ () => {
                                        if(formRenderProps.valid) {
                                            if(!validatePersWealthCnty(formRenderProps,authPer2,PersWealthSG2)) {
                                                showErrMsg(appDetailsData.label.ctrySourceWealth+": "+config.error.SelectChk5);
                                            }
                                            else {
                                                setShowAddBtn2(false);
                                                setIsAPDtlsEdited(true);
                                            }
                                        }
                                        else {
                                            showErrMsg('Input the blank fields');
                                        }
                                    }} />}
                                </div> }
                            </FieldWrapper> 
                            </div>}
                            {!showAddBtn2? 
                            <div>
                            <Field component={CusFormSectionLabel} 
                                leftLabelId={'lblAuthPer3'} leftLabelName={appDetailsData.label.authPer+' 3'} 
                                id={'AuthPer3'} name={selectedName3.Name} 
                                hasAuthUser={selectedName3.Name? true:false}
                                doneMyInfo={hasMyInfo3}
                                isExpend={isExpendAuth3} 
                                    onClick={() => {
                                        if(isExpendAuth3){
                                            setIsExpendAuth3(false);
                                        }
                                        else {
                                            setIsExpendAuth3(true);
                                        }
                                }} />

                            {isExpendAuth3 && <div>
                            <CusRemoveBtn id={'RemoveBtn2'} label={'REMOVE'} disabled={isSaveDone} onClick={() => {
                                MailAddrSameAsRes3 = 'Y';
                                PersWealthSG3 = 'Y';
                                showAuthPerson3 = false;
                                setShowAddBtn2(true);
                                setSelectedName3({});
                                setHasMyInfo3(false);
                                setIsAPDtlsEdited(true);
                                formRenderProps.onChange('nameCbo3', { value: '' });
                                formRenderProps.onChange('mno3', { value: '' });
                                formRenderProps.onChange('em3', { value: '' });
                                formRenderProps.onChange('titleCbo3', { value: '' });
                                formRenderProps.onChange('marStatusCbo3', { value: '' });
                                formRenderProps.onChange('counOfDomicileCbo3', { value: '' });
                                formRenderProps.onChange('MailAddType3', { value: '' });
                                formRenderProps.onChange('MailBlkNo3', { value: '' });
                                formRenderProps.onChange('MailStreet3', { value: '' });
                                formRenderProps.onChange('MailFlrNum3', { value: '' });
                                formRenderProps.onChange('MailUnitNo3', { value: '' });
                                formRenderProps.onChange('MailBldName3', { value: '' });
                                formRenderProps.onChange('MailPostalCode3', { value: '' });
                                formRenderProps.onChange('MailCountry3', { value: appDetailsData.DefCountry.label });
                                formRenderProps.onChange('DescActOcc13', { value: '' });
                                formRenderProps.onChange('DescActOcc23', { value: '' });
                                formRenderProps.onChange('DescActOcc33', { value: '' });
                                formRenderProps.onChange('SG3', { value: false });
                                formRenderProps.onChange('BN3', { value: false });
                                formRenderProps.onChange('MY3', { value: false });
                                formRenderProps.onChange('ID3', { value: false });
                                formRenderProps.onChange('IN3', { value: false });
                                formRenderProps.onChange('OTH3', { value: false });
                                formRenderProps.onChange('PersWealthOTH3', { value: '' });
                            }} />

                            <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.nameDDL.lblname}</div>
                                </div>
                                {hasMyInfo3?
                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }} onClick={onShowDetails}> 
                                    {showDetails? 
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Hide Details 
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                                        </span> :
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Show Details  
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                                        </span> }
                                    </div>
                                </div> :   
                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                </div>}
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                    <Field  id={'nameCbo'+authPer3} name={'nameCbo'+authPer3} 
                                        component={FormComboBox}
                                        textField={'Name'} clearButton={false}
                                        data={getHolders3()}
                                        placeholder={'Please select'}
                                        disabled={isSaveDone}
                                        validator={reqDDLValidator}
                                        onChange={(e)=> {
                                            if(e.value === null){
                                                return;
                                            }
                                            setIsAPDtlsEdited(true);
                                            showAuthPerson3 = true;
                                            setSelectedName3(e.value);
                                            if(e.value.IDNum === response.ApplicantsDtlsMyInfo.IDNum) {
                                                setHasMyInfo3(true);
                                                let obj = {
                                                    myInfo:response.ApplicantsDtlsMyInfo,
                                                    occupList:[],
                                                    allowEdit:true,
                                                    contactDtlEdit:true
                                                }
                                                setApplicantDetails3(obj);
                                                if(response.ApplicantsDtlsMyInfo.MarStatus !== null){
                                                    formRenderProps.onChange('marStatusCbo'+authPer3, { value: helper.getObjInArray(response.ApplicantsDtlsMyInfo.MarStatus,marStatusArray) });
                                                }
                                            }
                                            else{
                                                setHasMyInfo3(false);
                                            }

                                            formRenderProps.onChange('mno'+authPer3, { value: '' });
                                            formRenderProps.onChange('em'+authPer3, { value: '' });
                                        }}  /> 
                                    </div>
                                    </div>
                                </div>
                                {showAuthPerson3 && 
                                <AuthPerson applicantDetails={applicantDetails3} showDetails={showDetails}  formRenderProps={formRenderProps}
                                    hasMyInfo={hasMyInfo3} seq={authPer3} holders={holders}
                                    isPureSH={false}
                                    onRdoChange={onAuthPersonRdoChange}
                                    showErrMsg={(msg) => {showErrMsg(msg)}}
                                /> }
                            </FieldWrapper></div>}
                            </div>
                            :null}
                            </div>
                             }
                   
                        <FieldWrapper>
                            <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} /> 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                                    <button type={"button"} className="btn btn-back"  
                                        onClick={(e) => { e.preventDefault();  history.push(config.route.TxnActivities); }}>{config.btnName.Back}</button>
                                    <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                </div>
                            </div> 
                        
                        </FieldWrapper>
                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                                onClose={()=>{ setIsError(false)}} />} */}
                  
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                       
                        </fieldset>
                    </FormElement>
                    )}>
                    </Form>
                    </FormContainer>
                    {isSaving && <Loading />} 
        </div>
    )
}

export default NSApplicantDetails